import { render, staticRenderFns } from "./RidesPerAirport.vue?vue&type=template&id=617d9ef2&scoped=true&"
import script from "./RidesPerAirport.vue?vue&type=script&lang=js&"
export * from "./RidesPerAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d9ef2",
  null
  
)

export default component.exports